// @flow

import React, { Component } from "react";
import classNames from "classnames";
import type { WidgetProps } from "@rjsf/utils";
type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

class TextareaWidget extends Component<Props> {
  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    this.props.onChange(value);
  };

  get value() {
    return this.props.value || "";
  }

  render() {
    const props = {
      ...this.props,
      ...this.props.options,
      ...(this.props.schema && this.props.schema.hasOwnProperty("minimum")
        ? { min: this.props.schema.minimum }
        : {}),
      ...(this.props.schema && this.props.schema.hasOwnProperty("maxLength")
        ? { maxLength: this.props.schema.maxLength }
        : {}),
      onChange: this.handleChange,
      value: this.value,
    };

    if (props.readonly || (props.disabled && props.minimizeDisabled)) {
      return (
        <div className="schema-form-widget-textarea">
          <textarea
            disabled={props.disabled}
            readOnly={props.readonly}
            id={props.id}
            className={classNames("form-control", this.props.className)}
            rows={props.rows}
            value={props.value}
          />
        </div>
      );
    }

    return (
      <textarea
        disabled={props.disabled}
        id={props.id}
        rows={props.rows}
        maxLength={props.maxLength}
        name={props.name}
        onBlur={props.onBlur}
        onChange={props.onChange}
        onFocus={props.onFocus}
        placeholder={props.placeholder}
        readOnly={props.readonly}
        value={props.value}
        style={props.style}
        className={classNames("form-control", this.props.className)}
      />
    );
  }
}

export default TextareaWidget;
